// extracted by mini-css-extract-plugin
var _1 = "StakeFormStyle-module__agreementsWrapper___UYfww";
var _2 = "StakeFormStyle-module__amount___Rsb0T";
var _3 = "StakeFormStyle-module__button___F1k9b";
var _4 = "StakeFormStyle-module__buyEthBtn___FaBEs";
var _5 = "StakeFormStyle-module__checkboxWraper___Ot7DX";
var _6 = "StakeFormStyle-module__header___Ekn03";
var _7 = "StakeFormStyle-module__headerWrapper___udt4N";
var _8 = "StakeFormStyle-module__headerWrapperSection___AoLS9";
var _9 = "StakeFormStyle-module__input___JZ1EO";
var _a = "StakeFormStyle-module__label___VkTsD";
var _b = "StakeFormStyle-module__mainLabel___ZRdYx";
var _c = "StakeFormStyle-module__restaking___syUhV";
var _d = "StakeFormStyle-module__wrapper___qEbEP";
export { _1 as "agreementsWrapper", _2 as "amount", _3 as "button", _4 as "buyEthBtn", _5 as "checkboxWraper", _6 as "header", _7 as "headerWrapper", _8 as "headerWrapperSection", _9 as "input", _a as "label", _b as "mainLabel", _c as "restaking", _d as "wrapper" }
